import { render } from "./DiscountSelect.vue?vue&type=template&id=35d6ad81&scoped=true"
import script from "./DiscountSelect.vue?vue&type=script&lang=js"
export * from "./DiscountSelect.vue?vue&type=script&lang=js"

import "./DiscountSelect.vue?vue&type=style&index=0&id=35d6ad81&scoped=true&lang=scss"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d6ad81"]])

export default __exports__